import React, { useState, FormEvent, ChangeEvent } from "react"
import styled from "styled-components"

import { useStaticQuery, graphql } from "gatsby"
// TODO
import { regex_email } from "../../utils/validations/registerValidation"

import contactForm, { FORM_NAME } from "../../utils/netlifyForms/contactForm"
import OverlayForm, { Input, Textarea, ButtonSubmit } from '../OverlayForm'

const startingInputs = {
  name: {
    name: "name",
    value: "",
    label: "Name",
  },
  email: {
    name: "email",
    value: "",
    label: "Email",
  },
  message: {
    name: "message",
    value: "",
    label: "Message",
  },
}

interface ContactFormProps {
  show?: boolean
  onClose?: () => void
  location: Location
}

export default ({ show, onClose, location }: ContactFormProps) => {
  const data = useStaticQuery(
    graphql`
      query {
        contactImage: file(relativePath: { eq: "contactImage.jpg" }) {
          childImageSharp {
            fluid(quality: 20) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  )

  const [loading, setLoading] = useState(false)
  const [inputs, setInputs] = useState(startingInputs)
  const [errors, setErrors] = useState<any>({})
  const [submitted, setSubmitted] = useState(false)
  const [spinnerActive, setSpinnerActive] = useState(false)

  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const name = event.target.name
    const value = event.target.value
    const input = inputs[name]

    setInputs({
      ...inputs,
      [name]: { ...input, value: value },
    })
  }

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault()

    // Validation
    let errors: any = {}
    if (!inputs.name.value) {
      errors["name"] = "*name is required*"
    }
    if (!inputs.email.value) {
      errors["email"] = "*email is required"
    } else if (!regex_email.test(String(inputs.email.value).toLowerCase())) {
      errors["email"] = "*invalid email"
    }
    if (!inputs.message.value) {
      errors["message"] = "*message is required"
    }
    setErrors({ ...errors })

    // Check for errors
    if (Object.keys(errors).length !== 0) {
      return
    }

    setLoading(true)

    if (!loading) {
      contactForm({
        name: inputs.name.value,
        email: inputs.email.value,
        message: inputs.message.value,
        pathname: location.pathname,
      })
        .then(res => {
          setTitle("Thank you for contacting us")
          setText("We will answer as soon as possible.")
          setSubmitted(true)
          setSpinnerActive(false)
        })
        .catch(error => {
          console.error(error)
          setSpinnerActive(false)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }

  const [title, setTitle] = useState("Hi! Can we help you?")
  const [text, setText] = useState(
    "Do you need further information about the conference or do you need assistance? Send us a message and we will answer soon."
  )

  return (
    <OverlayForm
      title={title}
      text={text}
      show={show}
      onClose={onClose}
      imageFluid={data.contactImage}
    >
      <ModalForm className={submitted ? "submitted" : ""}>
        <form name={FORM_NAME} onSubmit={handleSubmit} noValidate>
          <input type="hidden" name="form-name" value={FORM_NAME} />

          <input
            type="hidden"
            name="website-page"
            value={location.pathname}
          />

          <Input 
            type="text"
            label={inputs.name.label}
            name={inputs.name.name}
            id={inputs.name.name}
            placeholder={inputs.name.label}
            onChange={handleChange}
            error={errors.name}
          />

          <Input 
            type="email"
            label={inputs.email.label}
            name={inputs.email.name}
            id={inputs.email.name}
            placeholder={inputs.email.label}
            onChange={handleChange}
            error={errors.email}
          />

          <Textarea
            label={inputs.message.label}
            name={inputs.message.name}
            id={inputs.message.name}
            placeholder={inputs.message.label}
            onChange={handleChange}
            error={errors.message}
          >
          </Textarea>

          <ButtonSubmit text="Send" loading={loading} spinnerActive={spinnerActive}/>
        </form>
      </ModalForm>
    </OverlayForm>
  )
}

const ModalForm = styled.div`
  &.submitted {
    pointer-events: none;
    opacity: 0;
  }
`
